export const MAX_TALK_NOTES = 12;

export function pushTalkNote(history, text, at) {
  const body = String(text || '').trim();
  const prev = Array.isArray(history) ? history : [];
  if (!body) return prev;
  if (prev[0]?.text === body) return prev;
  return [
    { id: `${Date.now()}-${prev.length}`, text: body, at: at || new Date().toISOString() },
    ...prev.filter((item) => item && item.text !== body),
  ].slice(0, MAX_TALK_NOTES);
}

export function currentTalkNote(notes) {
  return (notes && notes[0] && notes[0].text) || '';
}

export function previousTalkNotes(notes) {
  return Array.isArray(notes) ? notes.slice(1) : [];
}
